import script from "./CustomNode.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomNode.vue?vue&type=script&setup=true&lang=ts"

import "./CustomNode.vue?vue&type=style&index=0&id=5f3e26fe&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3e26fe"]])

export default __exports__